import { keys, isEmpty, propOr, values } from 'ramda';

const notEmpty = (value) => !isEmpty(value) && value;

export default (data, { config: { params } }) => {
    if (params.calendar) {
        return data;
    }

    const { days } = data;
    return params.participant ? personTimetableMapper(days) : trainerTimetableMapper(days);
};

const personTimetableMapper = (days = []) => {
    const items = [];

    days.forEach(day => day.items.forEach(
        event => items.push({
            date: day.date,
            ...event
        })
    ));

    return { items };
};

const trainerTimetableMapper = (days = []) => {
    const participants = {}, classes = {};

    days.forEach(day => {
        day.items.forEach(event => {
            if (notEmpty(event.participants)) {
                event.participants.forEach(participant => {
                    participants[participant.participantId] = {
                        ...propOr({}, participant.participantId, participants),
                        [event.id]: {
                            ...event,
                            ...participant
                        }
                    };
                });
            }

            classes[event.id] = { ...event };
        });
    });

    return {
        classes: values(classes),
        items: keys(participants).map(participantId => participants[participantId])
    };
};
